import Box from '@zenbusiness/zui/Box';
import ZuiHeading from '@zenbusiness/zui/Heading';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { superstyled } from '@zenbusiness/zui/styles';

export const Heading = superstyled({
  name: 'ZuiHeading',
  slot: 'Root',
  tag: ZuiHeading,
  propsAdded: {
    size: '2xl',
    weight: 'bold',
    lineHeight: '2xl',
    family: 'secondary',
    wrap: 'wrap'
  }
});

export const ImageContainer = superstyled({
  name: 'ZuiImageContainer',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    [theme.breakpoints.up('lg')]: {
      width: '150%'
    }
  })
});

export const HeaderImage = superstyled({
  name: 'ZuiHeaderImage',
  slot: 'Root',
  tag: SharedAsset,
  propsNeeded: ['objectposition'],
  styles: ({ theme, objectposition }) => ({
    width: '100%',
    minHeight: '10.25rem',
    objectPosition: objectposition,
    objectFit: 'cover',
    borderRadius: theme.shape.rounded['2xl'],

    [theme.breakpoints.up('lg')]: {
      height: '21.688rem'
    }
  })
});
